import React, {useCallback, useMemo} from 'react'
import {useSelector} from 'react-redux'
import {getIsFilterSelected, getLimitedFilters} from 'components/Filters/utils'
import {ShowMoreButton} from 'components/ShowMoreButton'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getFacetFilters} from 'modules/sapiSearch/selectors'
import {FilterUrlParam, FilterUrlParams} from 'modules/search/types'

import {Box} from '@vio/atlas/helpers/Box'
import {Checkbox} from '@vio/atlas/src/components/designSystem/Checkbox'

interface Props
  extends Pick<ReturnType<typeof useFiltersForm>, 'toggleMultiFilter'> {
  facet: keyof FilterUrlParams
  filters: FilterUrlParam
  appliedFilters: FilterUrlParam
  limit?: number
  isPopover?: boolean
  hasAppliedFilters: boolean
}
export const FacetsRenderCheckboxList: React.FC<Props> = ({
  facet,
  filters,
  appliedFilters,
  toggleMultiFilter,
  limit = 6,
  isPopover = false,
  hasAppliedFilters
}) => {
  const facetFilters = useSelector(getFacetFilters)
  const facetFiltersList = useMemo(
    () => [...Object.values(facetFilters?.[facet] || {})],
    [facetFilters, facet]
  )

  const [isLimited, setIsLimited] = React.useState(true)

  const visibleFilters = useMemo(() => {
    return getLimitedFilters(
      facetFiltersList,
      isLimited,
      limit,
      appliedFilters,
      hasAppliedFilters
    )
  }, [isLimited, facetFiltersList, limit, appliedFilters, hasAppliedFilters])

  const getIsFilterDisabled = useCallback(
    (themeId: string) => {
      return (
        !facetFilters?.[facet]?.[themeId]?.isAvailable &&
        !getIsFilterSelected(appliedFilters, themeId)
      )
    },
    [appliedFilters, facetFilters, facet]
  )

  return (
    <Box paddingBottom={isPopover ? 's500' : 's000'}>
      <Box
        display="grid"
        gap="s400"
        gridTemplateColumns="repeat(1, 1fr)"
        marginBottom="s400"
        desktopXs={{
          gridTemplateColumns: 'repeat(2, 1fr)'
        }}
      >
        {visibleFilters.map(facetFilter => (
          <Box key={facetFilter.id}>
            <Checkbox
              label={facetFilter.label}
              checked={getIsFilterSelected(filters, facetFilter.id)}
              disabled={getIsFilterDisabled(facetFilter.id)}
              onChange={() => toggleMultiFilter('themes', facetFilter.id)}
              name={facetFilter.label}
            />
          </Box>
        ))}
      </Box>
      {facetFiltersList.length > limit && (
        <ShowMoreButton
          isLimited={isLimited}
          onToggle={() => setIsLimited(prev => !prev)}
        />
      )}
    </Box>
  )
}
